module.exports = __webpack_public_path__ + "bg.7b644d4bcebcd9866e4a.jpg";


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles